$(document).ready(function() {
    function getDateFromText(text) {
        let match = text.match(/\[(\d{2}):(\d{2}):(\d{2});(\d{2})\.(\d{2})\.(\d{4})\]/);
        if (match) {
            let hours = parseInt(match[1], 10);
            let minutes = parseInt(match[2], 10);
            let seconds = parseInt(match[3], 10);
            let day = parseInt(match[4], 10);
            let month = parseInt(match[5], 10) - 1; // Měsíce v JS jsou indexované od 0
            let year = parseInt(match[6], 10);

            return new Date(year, month, day, hours, minutes, seconds, 0);
        }
        return null;
    }

    function startCountdown(targetDate) {
        let interval;
    
        function updateCountdown() {
            let now = new Date();
            let diff = targetDate - now;
    
            if (diff <= 0) {
                $("#countdown-text").text("Akce skončila");
                $(".site-msg.information").hide();
                clearInterval(interval);
                return;
            }
    
            let days = Math.floor(diff / (1000 * 60 * 60 * 24));
            let hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((diff % (1000 * 60)) / 1000);
    
            $("#countdown-text").html(
                `<span>${days}d</span> <span>${hours}h</span> <span>${minutes}m</span> <span>${seconds}s</span>`
            );
        }
    
        updateCountdown();
        interval = setInterval(updateCountdown, 1000); // přiřazení až po první spuštění
    }

    if($('#countdown-text').length){
        
        let text = $("#countdown-text").text(); // Očekává text ve formátu [hh:mm:ss;dd.mm.yyyy]
        if(text !== 'Akce skončila'){
            let targetDate = getDateFromText(text);
            if (targetDate) {
                startCountdown(targetDate);
            }
        }

    }
    
});
